<div class="no-data-found">
    <span>
        <img src="../../../../../../assets/images/nodata-removebg-preview.png" alt="no data found" />
    </span>
    <span class="text">No results found !!!</span>
</div>